module.exports = __webpack_public_path__ + "static/media/conductor-spot-forward-body@2x.cdd286f5.png";